module.exports = __webpack_public_path__ + "img/GZ.f74fc8eb.png";